import { render, staticRenderFns } from "./department-dialog-selector-instance.vue?vue&type=template&id=25c19356&"
import script from "./department-dialog-selector-instance.vue?vue&type=script&lang=js&"
export * from "./department-dialog-selector-instance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports